import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Layout from '../../components/Layout';
import { apiFetch } from '../../lib/api';
import { JobPec } from '../../types';

const STATO_BADGE: Record<string, string> = {
  BOZZA:      'bop-badge bop-badge--neutral',
  IN_CORSO:   'bop-badge bop-badge--info',
  COMPLETATO: 'bop-badge bop-badge--success',
  ERRORE:     'bop-badge bop-badge--danger',
};

export default function JobsPecPage() {
  const navigate          = useNavigate();
  const [jobs, setJobs]   = useState<JobPec[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    apiFetch<{ jobs: JobPec[] }>('/api/pec-massiva/jobs')
      .then((r) => setJobs(r.jobs))
      .catch((e) => setError(e.message))
      .finally(() => setLoading(false));
  }, []);

  return (
    <Layout>
      <div className="bop-page-header">
        <div className="bop-page-header__text">
          <h2 className="bop-page-title">Storico Job Email</h2>
          <p className="bop-page-subtitle">Tutti gli invii email massivi — passati e in corso</p>
        </div>
        <button className="bop-btn bop-btn-primary" onClick={() => navigate('/tecnico/pec-massiva')}>
          + Nuovo invio
        </button>
      </div>

      {error && <div className="bop-alert bop-alert--danger">{error}</div>}

      <div className="bop-card">
        <div className="bop-table-wrapper">
          {loading ? (
            <div className="bop-empty-state">Caricamento…</div>
          ) : jobs.length === 0 ? (
            <div className="bop-empty-state">Nessun job creato.</div>
          ) : (
            <table className="bop-table">
              <thead>
                <tr>
                  <th>#</th>
                  <th>Oggetto</th>
                  <th>Società</th>
                  <th>Stato</th>
                  <th>Progresso</th>
                  <th>SMTP</th>
                  <th>Errori</th>
                  <th>Creato il</th>
                  <th className="bop-jobs-pec__col-actions"></th>
                </tr>
              </thead>
              <tbody>
                {jobs.map((j) => {
                  const pct = j.totaleDestinatari > 0
                    ? Math.round((j.inviati / j.totaleDestinatari) * 100)
                    : 0;
                  return (
                    <tr key={j.id}>
                      <td className="bop-text-muted">{j.id}</td>
                      <td><strong>{j.oggetto}</strong></td>
                      <td className="bop-text-muted">{j.societaNome || '—'}</td>
                      <td>
                        <span className={STATO_BADGE[j.statoJob] ?? 'bop-badge bop-badge--neutral'}>
                          {j.statoJob}
                        </span>
                      </td>
                      <td>
                        <div className="bop-jobs-pec__progress-row">
                          <div className="bop-jobs-pec__progress-track">
                            {/* dynamic width: computed at runtime */}
                            <div className="bop-jobs-pec__progress-fill" style={{ width: `${pct}%` }} />
                          </div>
                          <span className="bop-jobs-pec__progress-label">
                            {j.inviati}/{j.totaleDestinatari}
                          </span>
                        </div>
                      </td>
                      <td>
                        {j.smtpHost ? (
                          <span className="bop-jobs-pec__smtp-cell">
                            <span className={`bop-badge ${j.smtpTipo === 'PEC' ? 'bop-badge--info' : 'bop-badge--neutral'}`}>
                              {j.smtpTipo ?? '—'}
                            </span>
                            {j.smtpHost}
                          </span>
                        ) : '—'}
                      </td>
                      <td>
                        {j.errori > 0
                          ? <span className="bop-jobs-pec__error-count">{j.errori}</span>
                          : <span className="bop-jobs-pec__no-error">—</span>}
                      </td>
                      <td className="bop-jobs-pec__date-cell">
                        {new Date(j.createdAt).toLocaleString('it-IT')}
                      </td>
                      <td>
                        <button
                          className="bop-btn bop-btn-ghost"
                          onClick={() => navigate(`/tecnico/pec-massiva/${j.id}`)}
                        >
                          Dettaglio
                        </button>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          )}
        </div>
      </div>
    </Layout>
  );
}
